import { render, staticRenderFns } from "./SelectStoryIntegratingWithInstagram.vue?vue&type=template&id=19f12050"
import script from "./SelectStoryIntegratingWithInstagram.vue?vue&type=script&lang=js"
export * from "./SelectStoryIntegratingWithInstagram.vue?vue&type=script&lang=js"
import style0 from "./SelectStoryIntegratingWithInstagram.vue?vue&type=style&index=0&id=19f12050&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports